  import firebase from "firebase/app";
  import "firebase/database";

export const constants = {
  namespaced: true,
  state: { constant: null },
  mutations: {
    setConstants(state, payload) {
      state.constant = { ...payload };
    }
  },
  actions: {
    fetchConstants(context) {
        firebase
          .database()
          .ref("constants")
          .once("value")
          .then(snapshot => {
            context.commit("setConstants", snapshot.val());
          });
      }},
    getters: {
      getConstants: state => () => state.constant
    }
  };



// WEBPACK FOOTER //
// ./src/store/modules/constants.js